import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "entityTitle",
    standalone: false
})
export class EntityTitlePipe implements PipeTransform {
  private readonly viewLabel = "View ";

  private readonly updateLabel = "Update ";

  private readonly createLabel = "Create ";

  transform(value: any, ...args: any[]): any {
    if (args.length > 0) {
      const isEntityReadOnly = args[0];
      if (isEntityReadOnly) {
        return this.viewLabel + value;
      }
      if (args[1]) {
        return this.updateLabel + value;
      }
    }
    return this.createLabel + value;
  }
}
